<template>
  <div class="">
    <MedicalPopup
      :isActive="isDetailsActive"
      :selectedMedical="selectedMedical"
      @close="toggleDetails"
    />
    <div class="relative">
      <img
        src="@/assets/images/line/Frame 1000002302.png"
        alt="lineimg"
        class="m-auto"
      />
      <div class="absolute bg-design-medc mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-medc-dots absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-mc-ecli absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="w-full mx-auto mb-8">
        <p
          class="title sm-fsize16 lg:font-medium md:font-medium font-bold pb-4"
        >
          Medical Conditions
        </p>
        <p class="subtitle lh32px sm-fsize14 bg-white">
          Home-based care could be long-term or short-term depending on the
          ailment. It can be overwhelming for a family caregiver who lacks the
          prerequisite skills or resource to manage the caregiving duties. Our
          services offer validated information, guidance, and support for the
          following set of health conditions.
        </p>
        <div
          class="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 md:gap-10 lg:gap-10 gap-4 md:pt-10 lg:pt-10 pt-6"
        >
          <!-- @click="toggleDetails(true, item)" -->
          <div
            class="rounded-lg cursor-pointer relative h-400"
            @click="handleClickpage(item.text)"
            v-for="(item, index) in medicalcards"
            :key="index"
            :style="{ 'background-color': item.color }"
          >
            <img
              :src="item.img"
              class="w-full object-cover h-full flex filter-b5"
              alt="medical condition"
            />
            <div class="absolute bottom-0 left-0 pb-3 px-3">
              <p class="fsize24-16 text-white font-semibold">
                {{ item.text }}
              </p>
              <p class="pt-1 ellipsis-2 fsize18-14px text-white">
                {{ item.description }}
              </p>
            </div>
          </div>
          <!-- <div class="card1bg p-8 rounded-2xl">
            <img
              src="../../../assets/images/caregiver/med-c2.svg"
              class="w-full m-auto h-40"
              alt="medical condition"
            />
            <p class="pt-6 mc-title">Cancer</p>
            <p class="pt-2 mc-subtitle ellipsis-3">
              Our bodies are made with billions of cells. When these cells are
              abnormal or get old, they usually die. Cancer starts with a
              malfunction of cells when the old or abnormal ones don't die even
              after new cells are formed. In this way the cancer cells crowd the
              normal ones, and our body finds it difficult to function.Cancer
              diagnosis causes complex feelings and lifestyle changes that can
              be overwhelming for many families. Cancer has a debilitating
              impact on physical needs including energy, appetite and general
              well-being and it is often emotionally and financially draining
              for the majority.
            </p>
          </div>
          <div class="card2bg p-8 rounded-2xl">
            <img
              src="../../../assets/images/caregiver/med-c3.svg"
              class="w-full m-auto h-40"
              alt="medical condition"
            />
            <p class="pt-6 mc-title">ALS</p>
            <p class="pt-2 mc-subtitle ellipsis-3">
              ALS (Lou Gehrig’s disease), or Amyotrophic Lateral Sclerosis,
              belongs to a wider group of disorders known as motor neuron
              diseases. It is a neurodegenerative disorder that affects nerve
              cells in the brain and the spinal cord. This progressive disease
              affects the nerve cells (neurons) responsible for controlling
              voluntary muscle movement. Voluntary muscles produce movements
              like chewing, walking, talking, moving, and even breathing.
              Currently, there is no cure for ALS, and neither is there any
              effective treatment to halt or reverse the progression of the
              disease.
            </p>
          </div>
          <div class="card1bg p-8 rounded-2xl">
            <img
              src="../../../assets/images/caregiver/med-c4.svg"
              class="w-full m-auto h-40"
              alt="medical condition"
            />
            <p class="pt-6 mc-title">Mental Illness</p>
            <p class="pt-2 mc-subtitle ellipsis-3">
              Mental health includes our emotional, psychological, and social
              well-being. Any disturbance or malfunction in these well-being
              leads to poor mental health. Several factors can contribute to
              risk for mental illness like trauma, history of abuse, ongoing
              medical conditions, biological factors or chemical imbalances in
              the brain. Effective treatments can include medication, therapies,
              psycho-social support, avoidance of risk factors such as consuming
              alcohol and other drug abuse and learning self-management skills
              to cope with various challenges.
            </p>
          </div>
          <div class="card2bg p-8 rounded-2xl">
            <img
              src="../../../assets/images/caregiver/covid19new.svg"
              class="w-full m-auto h-40"
              alt="medical condition"
            />
            <p class="pt-6 mc-title">Geriatric</p>
            <p class="pt-2 mc-subtitle ellipsis-3">
              Geriatric care is a general term describing the management of
              healthcare for older adults. Achieving and maintaining optimal
              health and wellness for older adults is more than a matter of just
              medicine. Both healthcare professionals and caregivers come
              together to manage health conditions and provide a safe, positive
              environment for the senior citizens of our society. In addition to
              treating disease specific conditions, there are other risks
              including delirium, age related dementia, falls, incontinence and
              negative interactions between medications. Geriatric care is hence
              important for the older adults to lead a good quality life.
            </p>
          </div>
          <div class="card1bg p-8 rounded-2xl">
            <img
              src="../../../assets/images/caregiver/als.svg"
              class="w-full m-auto h-40"
              alt="medical condition"
            />
            <p class="pt-6 mc-title">Covid</p>
            <p class="pt-2 mc-subtitle ellipsis-3">
              COVID-19 is an infectious disease caused by the SARS-CoV-2 virus.
              Most people infected with the virus experience mild to moderate
              respiratory illness and recover without requiring special
              treatment. However, some become seriously ill and require medical
              attention. Aged population and those with underlying medical
              conditions like cardiovascular disease, diabetes, chronic
              respiratory disease, or cancer are more likely to develop serious
              illness. COVID-19 symptoms include cough, fever or chills,
              shortness of breath or difficulty breathing, loss of taste or
              smell, muscle or body aches, sore throat, diarrhea, headache,
              nausea or vomiting, and congestion or runny nose. Getting
              vaccinated for Covid is essential.
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalPopup from "./MedicalPopup.vue";
export default {
  components: {
    MedicalPopup,
  },
  data() {
    return {
      selectedMedical: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          text: "Dementia",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. It can be of various kinds, Alzheimer’s being the most common one. Family caregivers of people with dementia are important to the quality of the patient’s life. The effects of being a long-term caregiver often includes psychological burden and social isolation. Our community, support groups and counselling offer you the time and space to share your experiences and unburden your closed emotions.",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Dementia.jpg",
          color: "#f1f1f199",
        },
        {
          id: "02",
          text: "Cancer",
          description:
            "Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care and home-based care offers you opportunities to create checks and balances for your long-term caregiving needs. ",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Cancer.jpg",
          color: "#e3ceff66",
        },
        {
          id: "03",
          text: "Neurological Disorders",
          description:
            "Amyotrophic Lateral Sclerosis or ALS is a neurological disorder that progressively leads to loss of voluntary muscle movements. Currently, there is no cure for ALS, and neither any effective treatment to halt or reverse the progression of the disease. Informal caregiving for a loved one with ALS can be physically and mentally stressful. Our educational resources and learning programmes can equip you with better knowledge and skills to provide effective caregiving. Simultaneously, our support services enable you to focus on your well-being.",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/ALS.jpg",
          color: "#f1f1f199",
        },
        {
          id: "04",
          text: "Palliative Care",
          description:
            "Palliative care is specialized medical care for people living with a serious illness, such as cancer or heart failure. Patients in palliative care may receive medical care for their symptoms, or palliative care, along with treatment intended to cure their serious illness. Palliative care is meant to enhance a person's current care by focusing on quality of life for them and their family. Here is a directory that will provide details and information for Palliative Care Centres. Here is a directory that will provide details for Palliative Care Centers ",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Palliative-Care.jpg",
          hlink:
            "https://www.palliativecare.in/palliative-care-centers-chandigarh/",
          sayhere: "here.",
          color: "#e3ceff66",
        },
      ],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedMedical = item;
    },
    handleClickpage(name) {
      if (name.trim() == "Neurological Disorders") {
        this.$router.push({ name: "medical_neurologicaldisorders" });
      } else if (name === "Dementia") {
        this.$router.push({ name: "medical_dementia" });
      } else if (name === "Palliative Care") {
        this.$router.push({ name: "medical_palliative" });
      } else if (name === "Cancer") {
        this.$router.push({ name: "medical_cancer" });
      }
    },
    openlink() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSdCtWfdefMnH1YR7CKXQa7zhewbh7nYxnaq4kP3rVt7Ti2MRQ/viewform"
      );
    },
  },
};
</script>
